"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disconnectClientSocket = exports.reconnectClientSocket = exports.offClientSocketEvent = exports.emitClientSocketEvent = exports.onClientSocketEvent = exports.startClientSocket = void 0;
const socket_io_client_1 = require("socket.io-client");
__exportStar(require("./constants"), exports);
const socketUri = process.env.NODE_ENV === "production"
    ? "https://urbanlinegas.com"
    : "http://localhost:8080";
let ClientSocket;
const eventListeners = new Map();
const getPlatform = () => {
    return /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "web";
};
const startClientSocket = (token) => {
    console.log("starting socket");
    if (!ClientSocket || !ClientSocket.connected) {
        ClientSocket = (0, socket_io_client_1.io)(socketUri, {
            withCredentials: true,
            auth: {
                token,
                platform: getPlatform(),
            },
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 2000,
        });
        ClientSocket.on("connect", () => {
            console.log("✅ Connected to server");
            reattachEventListeners();
        });
        ClientSocket.on("disconnect", (reason) => {
            console.warn(`⚠️ Disconnected: ${reason}`);
        });
        ClientSocket.on("reconnect_attempt", (attempt) => {
            console.info(`🔄 Reconnect attempt ${attempt}`);
        });
        ClientSocket.on("reconnect", (attempt) => {
            console.log(`✅ Reconnected after ${attempt} attempts`);
            reattachEventListeners(); // 🔄 Ensure events are reattached
        });
        ClientSocket.on("reconnect_failed", () => {
            console.error("❌ Reconnection failed. Please check your connection.");
        });
    }
    return ClientSocket;
};
exports.startClientSocket = startClientSocket;
const reattachEventListeners = () => {
    eventListeners.forEach((callback, event) => {
        ClientSocket.on(event, callback);
    });
};
const onClientSocketEvent = (event, callback) => {
    if (ClientSocket) {
        ClientSocket.on(event, callback);
        eventListeners.set(event, callback); // 🗃️ Store for reconnection
    }
};
exports.onClientSocketEvent = onClientSocketEvent;
const emitClientSocketEvent = (event, ...args) => {
    if (ClientSocket && ClientSocket.connected) {
        ClientSocket.emit(event, ...args);
    }
};
exports.emitClientSocketEvent = emitClientSocketEvent;
const offClientSocketEvent = (event, callback) => {
    if (ClientSocket) {
        if (callback) {
            ClientSocket.off(event, callback);
            eventListeners.delete(event);
        }
        else {
            ClientSocket.removeAllListeners(event);
            eventListeners.delete(event);
        }
    }
};
exports.offClientSocketEvent = offClientSocketEvent;
const reconnectClientSocket = (token) => {
    if (ClientSocket && !ClientSocket.connected) {
        console.warn("🔄 Attempting manual reconnection...");
        ClientSocket.connect();
    }
    else if (!ClientSocket) {
        console.warn("🔄 No active socket. Re-initializing...");
        (0, exports.startClientSocket)(token);
    }
    else {
        console.log("✅ Socket is already connected.");
    }
};
exports.reconnectClientSocket = reconnectClientSocket;
const disconnectClientSocket = () => {
    if (ClientSocket && ClientSocket.connected) {
        ClientSocket.disconnect();
        eventListeners.clear();
    }
};
exports.disconnectClientSocket = disconnectClientSocket;
//# sourceMappingURL=index.js.map